export default __webpack_public_path__ + "static/media/jump_via_cactus_icon.2f63f94d.png";